import {
  forwardRef,
  memo,
  ReactNode,
  useMemo,
} from 'react';
import type {
  ComponentProps,
  ForwardedRef,
  ReactElement,
} from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Button } from '../Button';
import type {
  ButtonProps,
} from '../Button';

export type ButtonLinkProps = Omit<ButtonProps<typeof Link>, 'component' | 'componentProps'> & {
  /**
   * иконка кнопки
   */
  icon?: ReactNode;
  /**
   * Параметр ссылки react-router-dom
   */
  to: ComponentProps<Link>['to'];
  /**
   * Параметр ссылки react-router-dom
   */
  target?: string;
};

const CenteredButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

function ButtonLinkInner(
  {
    className,
    to,
    target = undefined,
    disabled = false,
    icon = null,
    ...buttonProps
  }: ButtonLinkProps,
  ref: ForwardedRef<HTMLElement>,
): ReactElement {
  const content = icon || buttonProps.children;
  const onlyIcon = Boolean(icon) || buttonProps.onlyIcon;
  const ButtonComponent = useMemo<typeof Button>(
    () => (onlyIcon ? CenteredButton : Button),
    [onlyIcon],
  );

  if (disabled) {
    return (
      <ButtonComponent
        {...buttonProps}
        componentProps={{
          type: 'button',
        }}
        disabled
        onlyIcon={onlyIcon}
        ref={ref}
      >
        {content}
      </ButtonComponent>
    );
  }

  return (
    <ButtonComponent
      {...buttonProps}
      component={Link}
      componentProps={{
        to,
        target,
      }}
      onlyIcon={onlyIcon}
      ref={ref}
    >
      {content}
    </ButtonComponent>
  );
}

export const ButtonLink = memo(forwardRef(ButtonLinkInner));
